<template>
  <ion-card>
    <ion-card-header>
      <ion-card-title>{{ title }}</ion-card-title>
      <!-- <ion-card-subtitle>{{ kpi }}</ion-card-subtitle> -->
    </ion-card-header>

    <ion-card-content> {{ kpi }} </ion-card-content>
  </ion-card>
</template>

<script>
  import { IonCard } from '@ionic/vue'
  export default {
    name: 'KPIs',
    components: {
      IonCard
    },
    props: {
      title: String,
      kpi: String,
      progressCircular: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      values: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    computed: {
      computedTitle() {
        return this.title
      },
      computedValue() {
        return this.value
      }
    },
    data: () => ({
    }),
    created() {
    }
  }
</script>

<style>
  
</style>